export const API_BID_ENDPOINT = 'api/public/v3/bid/';
